<template>
    <h2 class="d-inline">{{ $trans.get('__JSON__.Sick notices') }}
        <div class="pt-1 pb-1 ps-2 pe-2 bg-danger text-white rounded-1 badge" style="font-size: 0.7rem; transform: translateY(-0.7rem);">
        {{ sortedSickNotices.length }} </div> </h2>
    <div class="d-inline float-end">
        <add-absence v-if="is('SuperAdmin | HR')" hr="1"/>
        <add-absence v-else hr="0"/>
    </div>
    <table class="table table-striped">
        <thead>
            <tr>
            <th role="button" @click.prevent="sortColumn='name'">{{ $trans.get('__JSON__.Name') }} <i v-if="sortColumn=='name'" class="fa fa-sort-asc"></i></th>
            <th>{{ $trans.get('__JSON__.Employer') }}</th>
            <th>{{ $trans.get('__JSON__.Employeenumber') }}</th>
            <th role="button" @click.prevent="sortColumn='start_at'">{{ $trans.get('__JSON__.From') }}  <i v-if="sortColumn=='start_at'" class="fa fa-sort-asc"></i></th>
            <th>{{ $trans.get('__JSON__.Until') }}</th>
            <th class="text-end">{{ $trans.get('__JSON__.Days') }}</th>
            <th class="text-end">{{ $trans.get('__JSON__.Action') }}</th>
            </tr>   
        </thead>
        <tbody>
            <tr class="infohover" v-for="employeeSickness in sortedSickNotices" :key="'es-' + employeeSickness.id">
                <td> <employee employeelink="1" :employee="employeeSickness.employee" />
                </td>
                <td>{{ employeeSickness.employee.employer.name }}</td>
                <td>{{ employeeSickness.employee.employeenumber }}</td>
                <td>{{ formatDate(employeeSickness.start_at) }}</td>
                <td>{{ formatDate(employeeSickness.end_at) }}</td>
                <td class="text-end"> {{ employeeSickness.workdays }}</td>
                <td class="text-end">

                    <i v-if="toOld(employeeSickness.requested_sick_certificate_at)" class="fa fa-warning text-danger" data-toggle="tooltip" title="Warnung älter als ein 14 Tage!"></i>
                    <i v-if="employeeSickness.requested_sick_certificate_at" class="fa fa-download text-success ml-2 me-2" v-tooltip
                        :title="$trans.get('Sick certificate requested')"></i>
                    <i v-if="!employeeSickness.requested_sick_certificate_at"
                        role="button" @click.stop="requested(employeeSickness.id)"
                            class="fa fa-download text-primary ml-2 me-2" v-tooltip
                            :title="$trans.get('__JSON__.Sick certificate requested')"></i>
                    <i role="button" @click.stop="certificate(employeeSickness.id)"
                            class="fa fa-check text-primary me-2" v-tooltip
                            :title="$trans.get('Sick certificate received')"></i>
                    <i role="button" @click.stop="nocertificate(employeeSickness.id)"
                            class="fa fa-circle-xmark text-danger me-2" v-tooltip
                            :title="$trans.get('No sick certificate')"></i>
                    <edit-absence-button :absence_id="'' + employeeSickness.id" v-tooltip
                        :title="$trans.get('__JSON__.Edit sick notice')" />
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import axios from "axios";
import employeeSickness from "../composables/employeeSickness";

export default {
    name: "EmployeeSicknessList",

    props: {
        monitor_others: Boolean,
        view_locations: Object
    },

    setup(props) {
        const { employee_sicknesses, employee_sickness_error_error, loadEmployeeSickness, saveEmployeeSickness } = employeeSickness();
        loadEmployeeSickness(props.monitor_others, props.view_locations);

      //  console.log('monitor others', props.monitor_others);
        return { employee_sicknesses, employee_sickness_error_error, loadEmployeeSickness, saveEmployeeSickness };
    },

    data() {
        return {
            sortColumn: 'created_at'
        };
    },
    
    created() {
        let refreshtime =  600000 + Math.floor(Math.random() * 120000);
        setInterval(this.refreshData,refreshtime)
        
        this.emitter.on('absence-edited', (evt) => {
            that.loadEmployeeSickness();
        }); 
    },

    computed: {
        sortedSickNotices() {
            // Div im Blade verstecken, wenn es keine Krankmeldungen gibt.
           // console.log("sicknessList: " , this.employee_sicknesses)
            if (!this.employee_sicknesses) {
                $('#sickNoticeContainer').css('display', 'none');
                return null;
            }
            if (this.employee_sicknesses.length == 0) {
                $('#sickNoticeContainer').css('display', 'none');
                return [];
            }

            $('#sickNoticeContainer').css('display', 'block');
            return this.employee_sicknesses.sort( this.compareSickness );
        }
    },
    methods: {
        compareSickness(a, b) {
            if (this.sortColumn == 'created_at') {
                if (a.created_at == b.created_at ) {
                    return 0;
                }

                if (a.created_at > b.created_at ) {
                    return -1;
                }
                return 1;
            }

            if (this.sortColumn == 'name') {
                if (a.employee.lastname > b.employee.lastname ) {
                    return 1;
                }

                if (a.employee.lastname < b.employee.lastname ) {
                    return -1;
                }

                if (a.employee.forename > b.employee.forename ) {
                    return 1;
                }

                if (a.employee.forename < b.employee.forename ) {
                    return -1;
                }

                if (a.start_at > b.start_at ) {
                    return 1;
                }

                if (a.start_at < b.start_at ) {
                    return -1;
                }

                return 0;
            }

            if (this.sortColumn == 'start_at') {
                if (a.start_at > b.start_at ) {
                    return 1;
                }

                if (a.start_at < b.start_at ) {
                    return -1;
                }

                if (a.employee.lastname > b.employee.lastname ) {
                    return 1;
                }

                if (a.employee.lastname < b.employee.lastname ) {
                    return -1;
                }

                if (a.employee.forename > b.employee.forename ) {
                    return 1;
                }

                if (a.employee.forename < b.employee.forename ) {
                    return -1;
                }

                return 0;
            }
                        
        },

        formatDate(date) {
            if (!date) {
                return null;
            }
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        },

        toOld( requestDate ) {
            if (!requestDate){
                return false;
            }

            var now = new Date();
            var requested = new Date(requestDate);
            if (now.getTime() - requested.getTime() > (14*24*60*60*1000)) {
                return true;
            }
            return false;
        },

        requested( id ) {
            axios.get('/vacations/' + id + '/sick_certificate_requested?redirect=0')
            .then((resp) => {
                console.log("axios", this.monitor_others);
                this.loadEmployeeSickness(this.monitor_others, this.view_locations);
                $('.tooltip').css('display', 'none');
            })
            .catch((error) => {
                console.log(error);
            });
        },

        certificate( id ) {
            axios.get('/vacations/' + id + '/sick_certificate_received?redirect=0')
            .then((resp) => {
                this.loadEmployeeSickness(this.monitor_others, this.view_locations);
                $('.tooltip').css('display', 'none');
            })
            .catch((error) => {
                console.log(error);
            });
        },

        nocertificate( id ) {
            axios.get('/vacations/' + id + '/no_sick_certificate?redirect=0')
            .then((resp) => {
                this.loadEmployeeSickness(this.monitor_others, this.view_locations);
                $('.tooltip').css('display', 'none');
            })
            .catch((error) => {
                console.log(error);
            });
        },
        refreshData() {
            this.loadEmployeeSickness(this.monitor_others, this.view_locations);
        },
    }
}
</script>

<style></style>